"use strict";

module.exports = function () {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simplemde-editor/lib/utils/noop.js
// module id = 1156
// module chunks = 0